<template>
  <nav :class="navClass" class="navbar navbar-expand-lg navbar-light fixed-top">
    <a class="navbar-brand" href="/">
      <img :src="logoImage" alt="Logo" class="logo" />
    </a>
    <button v-if="navType == 1" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarScroll"
      aria-controls="navbarScroll" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div v-if="navType == 1" class="collapse navbar-collapse justify-content-end" id="navbarScroll">
      <ul class="navbar-nav my-2 my-lg-0">

        <li class="nav-item">
          <a :class="linkColor" class="nav-link" href="/">首页</a>
        </li>
        <li class="nav-item">
          <a :class="linkColor" class="nav-link" href="/room">酒店住宿</a>
        </li>
        <li class="nav-item">
          <a :class="linkColor" class="nav-link" href="/media">影像纪事</a>
        </li>
        <li class="nav-item">
          <a :class="linkColor" class="nav-link" href="/artspace">艺术空间</a>
        </li>
        <li class="nav-item">
          <a :class="linkColor" class="nav-link" href="https://mp.weixin.qq.com/s/tLE7Dd5o0UrFUIb3YJHwmQ"
            target="_blank">关于我们</a>
        </li>

        <!-- 用户登录状态显示 -->
        <li v-if="$store.state.isLogin && isLogin" class="nav-item dropdown">
          <a :class="linkColor" class="nav-link dropdown-toggle  align-items-center gap-2" href="#" id="userDropdown"
            role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img :src="userInfo?.avatar" :alt="userInfo?.nickname" class="user-avatar" />
            <span>{{ userInfo?.nickname }}</span>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
            <!-- <a class="dropdown-item" href="/user/profile">个人中心</a> -->
            <!-- <a class="dropdown-item" href="/user/orders">我的订单</a> -->
            <div class="dropdown-item" @click.prevent="toMyorder">我的订单</div>
            <div class="dropdown-item" @click.prevent="handleLogout">退出登录</div>
            <!-- <div class="dropdown-divider"></div> -->
            <!-- <a class="dropdown-item" href="#" @click.prevent="handleLogout">退出登录</a> -->
          </div>
        </li>
        <li v-else class="nav-item">
          <a :class="linkColor" class="nav-link" href="/login">登录</a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { memberApi } from "@/utils/memberApi.js"
import { Message } from 'element-ui';


export default {
  props: {
    scrollNum: {
      type: null,
      default: 100, // 默认滚动100px后改变样式
    },
    navType: {
      type: null,
      default: 1
    }
  },
  data() {
    return {
      isTransparent: true,
      userInfo: null, // 本地管理用户信息，不再依赖父组件传入
      isLogin: null
    };
  },
  computed: {
    navClass() {
      return this.isTransparent ? "bg-transparent" : "bg-white shadow-sm";
    },
    logoImage() {
      return this.isTransparent
        ? require("@/assets/images/hotel-logo01.png")
        : require("@/assets/images/hotellogo.png");
    },
    linkColor() {
      return this.isTransparent ? "text-white" : "text-black";
    },
  },
  watch: {
    // 监听路由变化，同步更新登录状态（比如登录后跳转回首页时）
    $route() {
      this.loadUserInfo();
    },
  },
  onpageshow() {
    console.log('show');

  },
  mounted() {
    // 初始化时加载用户信息
    console.log('navtype', this.navType);
    console.log('mounted');


    this.loadUserInfo();
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 从本地存储加载用户信息
    loadUserInfo() {
      const storedUser = localStorage.getItem("userInfo");
      const loginType = localStorage.getItem("isLogin");
      if (storedUser) {
        try {
          this.userInfo = JSON.parse(storedUser);
          this.isLogin = JSON.parse(loginType);
        } catch (e) {
          console.error("解析用户信息失败", e);
          localStorage.removeItem("userInfo"); // 清除错误的存储数据
          this.userInfo = null;
        }
      } else {
        this.userInfo = null;
      }
    },
    handleScroll() {
      this.isTransparent = window.scrollY < this.scrollNum;
    },

    async toMyorder() {

      if (localStorage.getItem('isLogin') == 'true') {
        const res = await memberApi.getMemberInfo();
        if (res.errCode !== '000') {
          this.$store.commit('setLogin', false)
          Message.warning('登录超时，请重新登录！');
          this.toLogin()
        } else {
          this.$router.push({
            name: "order",
          });
        }

      } else {
        this.toLogin()

      }
    },

    toLogin() {
      this.$router.push('/login')
      localStorage.setItem('redirectAfterLogin', 'order')
    },


    // 处理退出登录
    handleLogout() {
      // 1. 清除本地存储的用户信息
      location.reload()
      // localStorage.removeItem("userInfo");
      localStorage.removeItem("isLogin");
      localStorage.removeItem("logingCode");
      // 2. 更新组件状态（立即隐藏用户信息，显示登录按钮）
      this.userInfo = null;
      // 3. 触发父组件事件（如需全局处理）
      this.$emit("logout");
      // 4. 提示退出成功
      this.$message.success("已成功退出登录");
      // 5. 跳转到首页（可选）
      // this.$router.push('/');
    },
  },
};
</script>

<style scoped lang="scss">
/* 样式保持不变 */
/* 透明背景样式 */
.bg-transparent {
  background-color: rgba(204, 204, 204, 0.473) !important;
  transition: background-color 0.3s ease;

  .dropdown-menu {
    background-color: rgba(255, 255, 255, 0.9);
    border: none;
  }

  .text-white {
    color: white !important;
  }
}

/* 白色背景样式 */
.bg-white {
  background-color: white !important;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  transition: background-color 0.3s ease, box-shadow 0.3s ease;

  .dropdown-menu {
    background-color: white;
  }

  .text-black {
    color: black !important;
  }
}

.navbar-brand {
  img {
    height: 50px;
  }
}

.collapse {

  ul,
  li {
    list-style: none;
    margin: 0;
    padding: 0;

    a {
      font-size: 23px;
      margin: 0 20px;
      text-decoration: none;
      transition: color 0.3s ease;
    }
  }
}

/* 用户头像样式 */
.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid white;
  transition: border-color 0.3s ease;
  margin-right: 10px;

  // 鼠标悬停效果
  &:hover {
    border-color: #fff;
  }
}

// 下拉菜单样式优化
.dropdown-menu {
  min-width: 180px;
  padding: 0.5rem 0;
  border-radius: 0 0 10px 10px;

  .dropdown-item {
    padding: 0.5rem 1rem;
    width: auto;
    transition: background-color 0.2s ease;
    text-align: center;
    cursor: pointer;

    &:hover {
      background-color: #f5f5f5;
    }
  }
}

// .nav-item {
//   font-family: 'font2', sans-serif;
//   font-size: 25px !important;
// }

// 响应式调整
@media (max-width: 992px) {
  .collapse {
    ul {
      margin-top: 1rem;
    }

    li {
      a {
        font-size: 18px;
        margin: 0 10px;
        padding: 0.5rem 0;
      }
    }
  }

  .user-avatar {
    width: 30px;
    height: 30px;
  }
}
</style>
